import { useContext } from 'react';
import I18n from 'I18n';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const TourStepCount = ({
  tourKey
}) => {
  const {
    tour
  } = useContext(TourContext);
  if (tour.getTour() !== tourKey) {
    return null;
  }
  const {
    steps
  } = tour.getConfig();
  const stepKey = tour.getStep();
  const stepIndex = steps.indexOf(stepKey);
  const totalSteps = steps.length;
  const stepText = I18n.text('shepherd-react.stepProgress', {
    currentStep: stepIndex + 1,
    totalSteps
  });
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    marginBlockEnd: "100",
    typography: "detail-100",
    color: "text-core-subtle",
    children: stepText
  });
};
export default TourStepCount;